import { render, staticRenderFns } from "./DeleteThirdPartyAlert.vue?vue&type=template&id=1f37b259"
import script from "./DeleteThirdPartyAlert.vue?vue&type=script&lang=js"
export * from "./DeleteThirdPartyAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports